import React, { useState, useEffect, useRef } from "react";
import { useUser } from "../../contexts/UserContext";

import "./Dashboard.css";
import {
  AddReservationButton,
  AddTicketButton,
  Chatrooms,
  CreateChatroomButton,
  CreateTransactionButton,
  Sidebar,
  TaskManager,
  TicketTable,
  PrimaryButton,
  UpcomingActions,
  PoolActionsTable,
} from "../../components";
import { PageStructure } from "../../pages";
import { Add, Task } from "@mui/icons-material";
import { Button } from "@mui/material";

const Dashboard = () => {
  const assignedTo = JSON.parse(localStorage.getItem("user"));
  const [buttonWidth, setButtonWidth] = useState(
    window.innerWidth <= 768 ? "100%" : "auto"
  );
  
  // Get current date in ISO format for filtering pool actions
  const today = new Date().toISOString().split('T')[0];
  
  return (
    <PageStructure>
      <h2>Dashboard</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "10px",
          marginBottom: "10px",
          overflowX: "auto",
        }}
      >
        {localStorage.getItem("legacy") !== "true" && (
          <>
            <AddTicketButton />
            <AddReservationButton />
            {/* <CreateChatroomButton /> */}
            <CreateTransactionButton />
          </>
        )}
      </div>

      <h3>Tickets assigned to me</h3>
      <TicketTable
        mini={true}
        searchUsers={
          assignedTo
            ? [
                {
                  value: {
                    _id: assignedTo._id || assignedTo.userId,
                    username: assignedTo.username,
                    role: assignedTo.role,
                    token: assignedTo.token,
                    name: assignedTo.name,
                  },
                  label: assignedTo.username,
                },
              ]
            : []
        }
        searchStatus={[
          {
            value: {
              color: "#09fbf7",
              title: "In Progress",
              __v: 0,
              _id: "660be69afebd962dd37c663d",
            },
            label: "In Progress",
          },
          {
            value: {
              color: "#11ff00",
              title: "Open",
              __v: 0,
              _id: "65fdd8c6ab895f5bb3aa645b",
            },
            label: "Open",
          },
        ]}
        // searchProperty={
        //   [
        //     {
        //       value: {
        //         _id: "66b1cbd5c950fd8f34219969"
        //       }
        //     }
        //   ]
        // }
        createdBy={false}
      />
      <button
        className="add-ticket-button__button"
        style={{
          backgroundColor: "var(--primary-color)",
          color: "var(--primary-text-color)",
          fontSize: "15px",
          fontWeight: "600",
          width: buttonWidth,
        }}
        onClick={() => {
          window.location.href = "/tickets/assigned-to-me";
        }}
      >
        View More
      </button>
      <div
        style={{
          display: JSON.parse(localStorage.getItem("user")).permissions
            .canViewCleanings
            ? "flex"
            : "none",
          flexDirection: "column",
        }}
      >
      <h3>Upcoming Cleanings</h3>
      <UpcomingActions />
      </div>

      {/* New section for Upcoming Pool Actions */}
      <div
        style={{
          display: JSON.parse(localStorage.getItem("user")).permissions
            .canAddPoolAction

            ? "flex"
            : "none",
            flexDirection: "column",
            alignItems: "flex-start",
        }}
      >
        <h3>Upcoming Pool Actions</h3>
        {/* Calculate today and 7 days from now for the pool actions filter */}
        {(() => {
          const today = new Date().toISOString().split('T')[0];
          const nextWeek = new Date();
          nextWeek.setDate(nextWeek.getDate() + 7);
          const nextWeekFormatted = nextWeek.toISOString().split('T')[0];
          
          return (
            <PoolActionsTable 
              mini={true}
              searchStartDate={today}
              searchEndDate={nextWeekFormatted}
              searchDone={{ value: false, label: 'In progress' }}
            />
          );
        })()}
        <button
          className="add-ticket-button__button"
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: buttonWidth,
          }}
          onClick={() => {
            window.location.href = "/pools/all";
          }}
        >
          View More
        </button>
      </div>

      <div
        style={{
          display: JSON.parse(localStorage.getItem("user")).permissions
            .canCreateTicket
            ? "flex"
            : "none",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <h3>Tickets Created by Me</h3>
        <TicketTable mini={true} createdBy={true} />
        <button
          className="add-ticket-button__button"
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: buttonWidth,
          }}
          onClick={() => {
            window.location.href = "/tickets/created-by-me";
          }}
        >
          View More
        </button>
      </div>
      <div
        style={{
          display: JSON.parse(localStorage.getItem("user")).permissions
            .canViewCompletedTickets
            ? "flex"
            : "none",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <h3>Completed Tickets</h3>
        <TicketTable
          mini={true}
          createdBy={false}
          searchStatus={[
            {
              value: {
                color: "#1909fb",
                title: "Completed",
                _id: "65fdd8ccab895f5bb3aa645e",
              },
              label: "Completed",
            },
          ]}
        />
        <button
          className="add-ticket-button__button"
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: buttonWidth,
          }}
          onClick={() => {
            window.location.href = "/tickets/completed";
          }}
        >
          View More
        </button>
      </div>

      <div
        style={{
          height: "300px",
        }}
      >
        {/* <Chatrooms /> */}
      </div>
    </PageStructure>
  );
};

export default Dashboard;
